// middleware/redirects.ts
export default defineNuxtRouteMiddleware((to, from) => {
  const localePath = useLocalePath()
  // Redirect based on the current route path
  if (['/eternity-rings', '/eternity-rings/'].includes(to.path)) {
    return navigateTo(localePath('/wedding-rings/eternity-rings'));
  }
  if (['/couple-rings', '/couple-rings/'].includes(to.path)) {
    return navigateTo(localePath('/wedding-rings/couple-rings'));
  }
  if (['/stud-earrings', '/stud-earrings/'].includes(to.path)) {
    return navigateTo(localePath('/fine-jewelry/stud-earrings'));
  }
  if (['/hoop-earrings', '/hoop-earrings/'].includes(to.path)) {
    return navigateTo(localePath('/fine-jewelry/hoop-earrings'));
  }
  if (['/tennis-necklace', '/tennis-necklace/'].includes(to.path)) {
    return navigateTo(localePath('/fine-jewelry/tennis-necklaces'));
  }
  if (['/solitaire-necklace', '/solitaire-necklace/'].includes(to.path)) {
    return navigateTo(localePath('/fine-jewelry/solitaire-necklaces'));
  }
  if (['/tennis-bracelet', '/tennis-bracelet/'].includes(to.path)) {
    return navigateTo(localePath('/fine-jewelry/tennis-bracelets'));
  }
  if (['/bangle-bracelets', '/bangle-bracelets/'].includes(to.path)) {
    return navigateTo(localePath('/fine-jewelry/bangle-bracelets'));
  }
  if (['/fashion-bracelets', '/fashion-bracelets/'].includes(to.path)) {
    return navigateTo(localePath('/fine-jewelry/fashion-bracelets'));
  }
  if (['/fashion-earrings', '/fashion-earrings/'].includes(to.path)) {
    return navigateTo(localePath('/fine-jewelry/fashion-earrings'));
  }
  if (['/womens-wedding-rings', '/womens-wedding-rings/'].includes(to.path)) {
    return navigateTo(localePath('/wedding-rings/womens-wedding-rings'));
  }
  if (['/anniversary-rings', '/anniversary-rings/'].includes(to.path)) {
    return navigateTo(localePath('/wedding-rings/anniversary-rings'));
  }
  if (['/fashion-necklaces', '/fashion-necklaces/'].includes(to.path)) {
    return navigateTo(localePath('/fine-jewelry/fashion-necklaces'));
  }
  if (['/initial-necklaces', '/initial-necklaces/'].includes(to.path)) {
    return navigateTo(localePath('/fine-jewelry/initial-necklaces'));
  }
  if (['/colored-diamond-rings', '/colored-diamond-rings/'].includes(to.path)) {
    return navigateTo(localePath('/high-jewelry/colored-diamond-rings'));
  }
  if (['/soiree-cocktail-jewelry', '/soiree-cocktail-jewelry/'].includes(to.path)) {
    return navigateTo(localePath('/high-jewelry/soiree-cocktail-jewelry'));
  }
  if (['/rose-portrait-jewelry', '/rose-portrait-jewelry/'].includes(to.path)) {
    return navigateTo(localePath('/high-jewelry/rose-portrait-jewelry'));
  }
  if (['/soiree-cocktail-jewellery','/soiree-cocktail-jewellery/'].includes(to.path)) {
    return navigateTo(localePath('/uk/high-jewellery/soiree-cocktail-jewellery'));
  }
  if (['/rose-portrait-jewelry', '/rose-portrait-jewelry/'].includes(to.path)) {
    return navigateTo(localePath('/high-jewelry/rose-portrait-jewelry'));
  }
  if (['/rose-portrait-jewellery', '/rose-portrait-jewellery/'].includes(to.path)) {
    return navigateTo(localePath('/uk/high-jewellery/rose-portrait-jewellery'));
  }  
  if (['/engagement-ring', '/engagement-ring/'].includes(to.path)) {
    return navigateTo(localePath('/engagement-rings'));
  }
  if (['/earrings', '/earrings/'].includes(to.path)) {
    return navigateTo(localePath('/earring-settings'));
  }
  if (['/pendant', '/pendant/'].includes(to.path)) {
    return navigateTo(localePath('/pendant-settings'));
  }
  if (['/blog/category', '/blog/category/'].includes(to.path)) {
    return navigateTo('/blog');
  }
  if (['/wedding-band', '/wedding-band/'].includes(to.path)) {
    return navigateTo('/wedding-rings/womens-wedding-rings');
  }
  if (['/index.php', '/index.php/', '/index', '/index/'].includes(to.path)) {
    return navigateTo('/');
  }
});
